import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../utils/redux';

export const consts = createReqConsts(
  'surveys',
  'upcoming-survey-cancel-filling',
);
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'users',
  type: 'post',
  slug: [
    {
      type: 'payload',
      selector: ['targetUserId'],
    },
    'upcoming_assignments',
    {
      type: 'payload',
      selector: ['assignmentId'],
    },
    'cancel_filling',
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/surveys/upcoming-survey-cancel-filling.js